import WidgetsIcon from '@mui/icons-material/Widgets';

interface Props {
  size: number;
  color: string;
}

export default function ProductsIcon({ size, color }: Props) {
  return (
    <WidgetsIcon sx={{ fontSize: size, color }} />
  )
}
